export default [
  'ADAC',
  'Adam Riese',
  'Advocard',
  'Allianz',
  'ConceptIF',
  'DMB Rechtsschutz',
  'Debeka',
  'ERGO',
  'HUK-Coburg',
  'Medien Rechtsschutz',
  'ROLAND Rechtsschutz',
  'ÖRAG-Rechtsschutz',
  'Zurich',
  'Württembergische',
  'Allrecht/DEURAG',
  'KS Auxilia',
  'VGH',
  'NRV Neue Rechtsschutz',
  'Mecklenburgische',
  'LVM Versicherung',
  'GVO Versicherung',
  'DA direkt',
  'Concordia',
  'BGV Badische Versicherungen',
];

export const alternative = 'andere Rechtsschutz';
export const legalInsuranceAliases = { 'HUK-Coburg': ['HUK24'], ERGO: ['D.A.S.'] };
